import { RouteConfig } from '../../../routing/types'

const ROUTE: RouteConfig = {
  name: 'topics-view-types-view',
  path: (params: { topicSlug: string; typeSlug: string }) =>
    `/topics/${params.topicSlug}/types/${params.typeSlug}`,
}

export default ROUTE
